import { useContext } from 'react'
import { DrawerType, DrawerContext } from './DrawerProvider'

const useDrawer: () => DrawerType = () => useContext(DrawerContext)

export default useDrawer
